import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Find = () => {

    const navigate = useNavigate();
    const [nationalCode,setNationalCode] = useState('');
    const [fetchedData,setFetchedData] = useState(false);
    const [children,setChildren] = useState([]);
    const [currentChild,setCurrentChild] = useState([]);

    const { readData } = useEntityCrud(`User/GetUserInfo?nationalCode=${nationalCode}`);
    const { readData: changeStatus } = useEntityCrud('User/ChangeStatus');

    const getChildren = () => {
        setChildren([])
        setFetchedData(false)
        const postedData = {
            nationalCode
        }
        readData(postedData).then(({data}) => {
            if(data.status)
                setChildren(data.result.childUsers);
            else
                toast.error('کاربر در سیستم یافت نشد')
        }).finally(() => {
            setFetchedData(true);
        })
    }
    
    const changeUserStatus = (child,status) => {
        const postedData = {
            id: child.id,
            status
        }
        changeStatus(postedData).then(({data}) => {
            if(data.status){
                toast.success('وضعیت فرزند با موفقیت به روزرسانی شد');
                getChildren();
            }else
                toast.error('به روزرسانی وضعیت فرزند ناموفق بود');
        })
    }

    return (
        <div className="card">
            <div className="card-header">
                <div className="card-title">فرزندان</div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <label>کد ملی والد</label>
                            <input type="tel" className="form-control ltr-input" value={nationalCode} onChange={e => setNationalCode(e.target.value)} maxLength={10} />
                        </div>
                    </div>
                    <div className="col-md-2" style={{marginTop: 30}}>
                        <button className="btn btn-primary px-5" disabled={!nationalCode || nationalCode.length != 10} onClick={getChildren}>جستجو</button>
                    </div>
                </div>
                {fetchedData ? <hr /> : ''}
                {fetchedData ? (children.length ? <div className="table-responsive">
                    <table className="table table-bordered table-hover border text-nowrap text-md-nowrap">
                        <thead>
                            <tr>
                                <th>ردیف</th>
                                <th>نام</th>
                                <th>نام خانوادگی</th>
                                <th>کد ملی</th>
                                <th>شماره همراه</th>
                                <th>عملیات</th>
                            </tr>
                        </thead>
                        <tbody>
                            {children.map((child,index) => <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{child.firstName}</td>
                                <td>{child.lastName}</td>
                                <td>{child.nationalCode}</td>
                                <td>{child.mobile}</td>
                                <td>
                                    {!child.isActive ? <button className="btn btn-success me-1" onClick={() => changeUserStatus(child,true)}>فعال کردن</button> : ''}
                                    {child.isActive ? <button className="btn btn-danger me-1" onClick={() => changeUserStatus(child,false)}>غیرفعال کردن</button> : ''}
                                    <button className="btn btn-info me-1" data-bs-toggle="modal" data-bs-target="#segments" onClick={() => setCurrentChild(child)}>منابع مالی</button>
                                    <button className="btn btn-dark" onClick={() => navigate(`/transactionlist?nationalCode=${child.nationalCode}`)}>تراکنش ها</button>
                                </td>
                            </tr>)}
                        </tbody>
                    </table>
                    <div className="modal fade" id="segments" tabindex="-1" aria-hidden="true">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-6">منابع مالی</h1>
                                    <button type="button" className="btn-close fs-6" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    {currentChild.segmentInformation && currentChild.segmentInformation.v_result && currentChild.segmentInformation.v_result.length ? <div className="table-responsive">
                                        <table className="table table-bordered table-hover border text-nowrap text-md-nowrap mb-0">
                                            <thead>
                                                <tr>
                                                    <th>ردیف</th>
                                                    <th>عنوان</th>
                                                    <th>میزان تخصیص یافته</th>
                                                    <th>موجودی فعلی</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentChild.segmentInformation.v_result.map((segment,index) => <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{segment.title}</td>
                                                    <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(segment.limit)} ریال</td>
                                                    <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(segment.remaind)} ریال</td>
                                                </tr>)}
                                            </tbody>
                                        </table>
                                    </div> : <div className="alert alert-warning"><p className="mb-0">منبع مالی برای این شخص یافت نشد</p></div>}
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-light" data-bs-dismiss="modal">بستن</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> : <div className="alert alert-warning"><p className="mb-0">برای این کاربر فرزندی در سیستم ثبت نشده است</p></div>) : ''}
            </div>
        </div>
    )
}

export default Find